import { connect } from "react-redux";
import { IState } from "../../../../App/reducer";
import { ImportReportComponent } from "./ImportReport.component";
import { IImportReportStateProps } from "./ImportReport.types";

const mapStateToProps = (state: IState): IImportReportStateProps => ({
  report: state.App.CourseAuthor._.importReport,
});

export const ImportReport = connect(mapStateToProps)(ImportReportComponent);
